"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UTM_PARAMS_COOKIE = exports.TERMS_OF_USE = exports.SITEMAP = exports.SEM_FORM_ID = exports.SATELLITE_OFFICE_TITLE = exports.PRIVACY = exports.NEWSLETTER_SUBSCRIBE = exports.MODAL_Display = exports.LEADS_CTA_LABEL = exports.FETCH_AGENCY_LIST = exports.FETCH_AGENCY_ADDRESS_AUTOCOMPLETE = exports.EMAIL_REG_EXP = exports.CPRA = exports.CORE_OFFICE_TITLE = exports.CALENDLY_CTA_LABEL = exports.ALERT_NOTIFICATION = void 0;
// Form Validation RegExp
var EMAIL_REG_EXP = exports.EMAIL_REG_EXP = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
var NEWSLETTER_SUBSCRIBE = exports.NEWSLETTER_SUBSCRIBE = {
  'FORM_NAME': 'MMFA_Newsletter',
  'LEAD_SOURCE': 'Newsletter Sign Up',
  'RESPONSE_TYPE': 'Lead_form_response',
  'VISITOR_CONVERSION': 'Web'
};

// Misc
var UTM_PARAMS_COOKIE = exports.UTM_PARAMS_COOKIE = 'UtmParms';
var SEM_FORM_ID = exports.SEM_FORM_ID = 'SemFormId';
var ALERT_NOTIFICATION = exports.ALERT_NOTIFICATION = 'mmcom-notification-[id]';
var TERMS_OF_USE = exports.TERMS_OF_USE = 'term';
var PRIVACY = exports.PRIVACY = 'privacy';
var SITEMAP = exports.SITEMAP = 'sitemap';
var CPRA = exports.CPRA = 'cpra';
var MODAL_Display = exports.MODAL_Display = 'mmcom-modal-[id]';
var FETCH_AGENCY_ADDRESS_AUTOCOMPLETE = exports.FETCH_AGENCY_ADDRESS_AUTOCOMPLETE = '/apicalls/addressautocomplete';
var FETCH_AGENCY_LIST = exports.FETCH_AGENCY_LIST = '/apicalls/agencylist';
var CORE_OFFICE_TITLE = exports.CORE_OFFICE_TITLE = 'Main Office';
var SATELLITE_OFFICE_TITLE = exports.SATELLITE_OFFICE_TITLE = 'Satellite Offices';
var CALENDLY_CTA_LABEL = exports.CALENDLY_CTA_LABEL = 'calendly';
var LEADS_CTA_LABEL = exports.LEADS_CTA_LABEL = 'lead';